

define(['angular', 'squid/index', './country', './language'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('locale.resolvers', [// eslint-disable-line angular/no-service-method
    'locale.resolvers.country', 'locale.resolvers.language']).service('$LocaleResolver', function ($locale, $Class, $util, $logger, $CountryResolvers, $LanguageResolvers, $config, $q) {

        var LocaleResolver = $Class.extend('LocaleResolver', {

            registerCountryResolver: function registerCountryResolver(name, resolver) {
                $CountryResolvers[name] = resolver;
            },

            registerLangResolver: function registerLangResolver(name, resolver) {
                $LanguageResolvers[name] = resolver;
            },

            resolvePromiseChain: function resolvePromiseChain(resolvers, validator, args) {

                var self = this;
                var promise = $q.when();
                var result;

                angular.forEach(resolvers, function (resolver) {

                    promise = promise.then(function () {

                        if (result) {
                            return result;
                        }

                        return $q.when(resolver.method.apply(self, args || [])).then(function (resolved) {

                            if (resolved && validator(resolved)) {
                                result = {
                                    resolver: resolver.name,
                                    resolved: resolved
                                };
                                return result;
                            }
                        });
                    }, angular.noop);
                });

                return promise;
            },

            resolveCountry: function resolveCountry() {

                var validator = function validator(country) {
                    return Boolean(country && $config.supportedCountries[country]);
                };

                var resolvers = $util.map($config.locale.country.resolvers, function (name) {
                    $CountryResolvers[name].name = name;
                    return $CountryResolvers[name];
                });

                return this.resolvePromiseChain(resolvers, validator).then(function (resolved) {
                    $logger.debug('resolve_country', {
                        country: resolved.resolved,
                        resolver: resolved.resolver
                    });
                    return resolved.resolved;
                });
            },

            resolveLanguage: function resolveLanguage(country) {

                var validator = function validator(language) {
                    return Boolean($config.supportedCountries[country].indexOf(language) > -1);
                };

                var resolvers = $util.map($config.locale.lang.resolvers, function (name) {
                    $LanguageResolvers[name].name = name;
                    return $LanguageResolvers[name];
                });

                return this.resolvePromiseChain(resolvers, validator, [country]).then(function (resolved) {
                    $logger.debug('resolve_lang', {
                        lang: resolved.resolved,
                        resolver: resolved.resolver
                    });
                    return resolved.resolved;
                });
            },

            setUserPreferredCountry: function setUserPreferredCountry(country) {
                $util.assert(country, 'No country provided');
                this.userPreferredCountry = country;
            },

            setUserPreferredLanguage: function setUserPreferredLanguage(language) {
                $util.assert(language, 'No language provided');
                this.userPreferredLanguage = language;
            },

            resolve: function resolve(preventContentLoad) {

                var self = this;

                function resolveCountry() {
                    if (self.userPreferredCountry) {
                        return $q.when(self.userPreferredCountry);
                    }

                    return self.resolveCountry();
                }

                function resolveLanguage(country) {
                    if (self.userPreferredLanguage) {
                        return $q.when(self.userPreferredLanguage);
                    }

                    return self.resolveLanguage(country);
                }

                return resolveCountry().then(function (country) {
                    return resolveLanguage(country).then(function (language) {
                        return {
                            language: language,
                            country: country
                        };
                    });
                }).then(function (result) {
                    return $locale.change(result.country, result.language, preventContentLoad);
                });
            }

        });

        return new LocaleResolver();
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-locale/dist/resolvers.js
// module id = ./components/xo-locale/dist/resolvers.js
// module chunks = 1